module.exports = "/next-static/_next/static/images/block_image_one_2x-4f133e399100655a62e6d5bd75acc882.webp";